var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessageIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1229_17789)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#49943E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.281 19.0312C27.2114 19.1009 27.1287 19.1563 27.0376 19.194C26.9466 19.2318 26.849 19.2512 26.7504 19.2512C26.6519 19.2512 26.5543 19.2318 26.4632 19.194C26.3722 19.1563 26.2894 19.1009 26.2198 19.0312L20.7504 13.5609V28.2506C20.7504 28.4495 20.6714 28.6403 20.5307 28.7809C20.3901 28.9216 20.1993 29.0006 20.0004 29.0006C19.8015 29.0006 19.6107 28.9216 19.4701 28.7809C19.3294 28.6403 19.2504 28.4495 19.2504 28.2506V13.5609L13.781 19.0312C13.6403 19.1719 13.4494 19.251 13.2504 19.251C13.0514 19.251 12.8605 19.1719 12.7198 19.0312C12.5791 18.8905 12.5 18.6996 12.5 18.5006C12.5 18.3016 12.5791 18.1107 12.7198 17.97L19.4698 11.22C19.5394 11.1502 19.6222 11.0949 19.7132 11.0572C19.8043 11.0194 19.9019 11 20.0004 11C20.099 11 20.1966 11.0194 20.2876 11.0572C20.3787 11.0949 20.4614 11.1502 20.531 11.22L27.281 17.97C27.3508 18.0396 27.4061 18.1223 27.4438 18.2134C27.4816 18.3044 27.501 18.402 27.501 18.5006C27.501 18.5992 27.4816 18.6967 27.4438 18.7878C27.4061 18.8788 27.3508 18.9616 27.281 19.0312Z",
    fill: "#FAF7EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1229_17789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageIconDark);
export default __webpack_public_path__ + "static/media/send-message-icon-dark.85ac31009d4fdb782cdc55e9b891e7fe.svg";
export { ForwardRef as ReactComponent };